import { __decorate, __metadata, __param } from 'tslib';
import { Inject, Injectable, LOCALE_ID, NgModule } from '@angular/core';
import { TranslationWidth } from '@angular/common';
import { NbDateService } from '@nebular/theme';
import * as _rollupMoment from 'moment';
import _rollupMoment__default from 'moment';

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// @ts-ignore
import * as ɵngcc0 from '@angular/core';
const moment = _rollupMoment__default || _rollupMoment;
let NbMomentDateService = class NbMomentDateService extends NbDateService {
    constructor(locale) {
        super();
        this.setLocale(locale);
    }
    setLocale(locale) {
        super.setLocale(locale);
        this.setMomentLocaleData(locale);
    }
    addDay(date, days) {
        return this.clone(date).add({ days });
    }
    addMonth(date, months) {
        return this.clone(date).add({ months });
    }
    addYear(date, years) {
        return this.clone(date).add({ years });
    }
    clone(date) {
        return date.clone().locale(this.locale);
    }
    compareDates(date1, date2) {
        return this.getYear(date1) - this.getYear(date2) ||
            this.getMonth(date1) - this.getMonth(date2) ||
            this.getDate(date1) - this.getDate(date2);
    }
    createDate(year, month, date) {
        return moment([year, month, date]);
    }
    format(date, format) {
        if (date) {
            return date.format(format || this.localeData.defaultFormat);
        }
        return '';
    }
    getDate(date) {
        return this.clone(date).date();
    }
    getDayOfWeek(date) {
        return this.clone(date).day();
    }
    getDayOfWeekNames(style = TranslationWidth.Narrow) {
        return this.localeData.days[style];
    }
    getFirstDayOfWeek() {
        return this.localeData.firstDayOfWeek;
    }
    getMonth(date) {
        return this.clone(date).month();
    }
    getMonthEnd(date) {
        return this.clone(date).endOf('month');
    }
    getMonthName(date, style = TranslationWidth.Abbreviated) {
        const month = this.getMonth(date);
        return this.getMonthNameByIndex(month, style);
    }
    getMonthNameByIndex(month, style = TranslationWidth.Abbreviated) {
        return this.localeData.months[style][month];
    }
    getMonthStart(date) {
        return this.clone(date).startOf('month');
    }
    getNumberOfDaysInMonth(date) {
        return this.clone(date).daysInMonth();
    }
    getYear(date) {
        return this.clone(date).year();
    }
    getYearEnd(date) {
        return this.clone(date).endOf('year');
    }
    getYearStart(date) {
        return this.clone(date).startOf('year');
    }
    isSameDay(date1, date2) {
        return this.isSameMonth(date1, date2) && this.getDate(date1) === this.getDate(date2);
    }
    isSameMonth(date1, date2) {
        return this.isSameYear(date1, date2) && this.getMonth(date1) === this.getMonth(date2);
    }
    isSameYear(date1, date2) {
        return this.getYear(date1) === this.getYear(date2);
    }
    isValidDateString(date, format) {
        return moment(date, format).isValid();
    }
    parse(date, format) {
        return moment(date, format);
    }
    today() {
        return moment();
    }
    getId() {
        return 'moment';
    }
    setMomentLocaleData(locale) {
        const momentLocaleData = moment.localeData(locale);
        this.localeData = {
            firstDayOfWeek: momentLocaleData.firstDayOfWeek(),
            defaultFormat: momentLocaleData.longDateFormat('L'),
            months: {
                [TranslationWidth.Abbreviated]: momentLocaleData.monthsShort(),
                [TranslationWidth.Wide]: momentLocaleData.months(),
            },
            days: {
                [TranslationWidth.Wide]: momentLocaleData.weekdays(),
                [TranslationWidth.Short]: momentLocaleData.weekdaysShort(),
                [TranslationWidth.Narrow]: momentLocaleData.weekdaysMin(),
            },
        };
    }
    getWeekNumber(date) {
        return date.week();
    }
};
NbMomentDateService.ɵfac = function NbMomentDateService_Factory(t) { return new (t || NbMomentDateService)(ɵngcc0.ɵɵinject(LOCALE_ID)); };
NbMomentDateService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NbMomentDateService, factory: function (t) { return NbMomentDateService.ɵfac(t); } });
NbMomentDateService = __decorate([ __param(0, Inject(LOCALE_ID)),
    __metadata("design:paramtypes", [String])
], NbMomentDateService);

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
let NbMomentDateModule = class NbMomentDateModule {
};
NbMomentDateModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NbMomentDateModule });
NbMomentDateModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NbMomentDateModule_Factory(t) { return new (t || NbMomentDateModule)(); }, providers: [{ provide: NbDateService, useClass: NbMomentDateService }] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NbMomentDateService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [LOCALE_ID]
            }] }]; }, null); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NbMomentDateModule, [{
        type: NgModule,
        args: [{
                providers: [{ provide: NbDateService, useClass: NbMomentDateService }]
            }]
    }], null, null); })();

/*
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NbMomentDateService, NbMomentDateModule };

//# sourceMappingURL=data:application/json;charset=utf-8;base64,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